<template>
    <div>
        <div  v-if="guestChoices">
            <transition-group name="slide-fade">
                <div class="box p-sm " :class="[checkout ? 'warning-border':'']" v-for="(choice, index) in guestChoices" :key="index+1">
                    <div>
                        <span class="is-size-6 has-text-weight-bold" v-if="choice">{{ choice.offer.name.fr }}</span>
                    </div>
                    <div v-if="choice.session">
                        <div class="is-size-7" v-if="choice">{{ choice.session.campus.name }}</div>
                        <div class="is-size-7" v-if="choice">
                            <i>{{ choice.session.begin | moment }}</i> au <i>{{ choice.session.end | moment }}</i>
                            <div v-if="sessionGuestConflict({candidate:null, choice})">

                                <span class="has-text-danger">{{ $t('shop.cart.session_conflict') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="m-sm" v-if="checkout" >

                        <span class="m-sm" v-if="hasCandidates" v-for="candidate in activeCandidates">
                            <span class="button has-background-primary has-text-light"
                                    @click="addGuestChoiceToCart({candidate, offer:choice.offer, school, session:choice.session})">
                                {{ $t('shop.offers.register') }}
                            </span>
                        </span>

                    </div>

                <div class="columns">
                    <div class="column">

                    </div>

                    <div class="column is-6 has-text-right">
                        <a class="m-r-sm" @click="removeGuestChoiceFromCart({candidate:null, choice})">
                            {{ $t('labels.general.delete') }}
                        </a>
                        <span v-if="choice.session">
                            <strong><i>{{ choice.offer.price }} {{ schoolFees }}</i></strong>
                        </span>
                        <span v-else>
                            <strong><i>{{ offerFees(choice.offer.prices) }}</i></strong>
                        </span>
                    </div>

                </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>

    import {mapActions, mapGetters} from 'vuex'
    import NewChildForm from '../NewChildForm'

    export default {
        data () {
            return {
                childFormView: NewChildForm,
                showChildForm: false
            }
        },
        props: {
            checkout: { type: Boolean },
            status: { type: String }
        },
        computed: {
            ...mapGetters(
                'auth', [
                    'getAccount'
                ]
            ),
            ...mapGetters(
                'orders', [
                    'guestOfferChoices',
                    'sessionGuestConflict',
                    'checkoutStatus'
                ]
            ),
            ...mapGetters('candidate', [
                'hasCandidates',
                'activeCandidates',
            ]),
            ...mapGetters(
                'organization', [
                    'getSchoolBySlug'
                ]
            ),
            guestChoices() {
                return this.guestOfferChoices
            },
            school() {
                return this.getSchoolBySlug(this.$route.params.school)
            },
            schoolFees() {
                return this.school ? this.school.fees_currency:null
            },

        },
        methods: {
            ...mapActions(
                'orders', [
                    'removeGuestChoiceFromCart',
                    'addGuestChoiceToCart',
                    'saveChoice'
                ]
            ),
            displayChildForm () {
                this.showChildForm = true
                this.$scrollTo('#child-form-view', {offset: 10}, 200)
            },
            offerFees (prices) {
                const school = this.getSchoolBySlug(this.$route.params.school)
                if (school) {
                    return prices.filter(function (price) {
                        return price.school_id === school.id
                    }).map(price => price.price+' '+price.currency)[0];
                }

            },
            saveCandidate() {
                this.showChildForm = false
            },
        },
        filters: {
            moment: function (date) {
                return moment(date).format('LL')
            }
        },
        created () {

        }
    }
</script>

<style scoped>

</style>
